<template>
  <div class="comment-wrapper">
    <h3 class="section-title">댓글쓰기</h3>
    <template v-if="logined">
    <div class="comment-input-wrapper">
      <div class="comment-input-user-profile background-image"
           :style="{'background-image': 'url(' + getPhotoUrl(photoUrl) + ')'}"></div>
      <div class="comment-input-box">
        <textarea v-model.trim="content" class="comment-input-box__textarea" placeholder="댓글을 작성해주세요." title="댓글내용입력란"></textarea>
        <div class="comment-input-box__submit-box">
          <p class="comment-input-box__count">{{content_length}}/300</p>
          <button class="comment-input-box__submit-btn" @click="addComment">등록</button>
        </div>
      </div>
    </div>
    </template>
    <template v-if="!logined">
    <div class="comment-input-wrapper">
      <p><a href="login.do">로그인</a>하시면 댓글쓰기를 할 수 있습니다.</p>
    </div>
    </template>

    <template v-if="comments.length != 0">
    <div>
      <h3 class="section-title">전체댓글수 <span class="section-title__helper">({{comments.length}})</span></h3>
      <ul class="comments-list">
        <li class="comment-box over-layer-infobox" v-for="(comment, index) in comments">
          <div class="comment-box__user-profile background-image overImg" @mouseover="showMntPrfl(index)" @mouseout="closeMntPrfl(index)"
               :style="{'background-image': 'url(' + getPhotoUrl(comment.photoUrl) + ')'}">
          </div>
          <div class="info-view-layer" :id="'info-view-layer-' + index" v-if="isMemberPost && getMntoName(comment.id) !== ''">
            <div class="box">
              <div class="arr"></div>
              <div class="tit">{{getMntoName(comment.id)}}</div>
              <ul>
                <li v-for="profile in getMntoProfile(comment.id)">{{profile}}</li>
              </ul>
            </div>
          </div>
          <h5 class="comment-box__name">{{comment.loginid}}
            <button class="like-btn like-btn--small" :class="{ liked: isMyLike(comment.id)}"
                    @click="addLike(comment.id)">
              <i class="fa fa-heart liked-heart"></i>
              <i class="fa fa-heart-o"></i>
              <p class="alt-text">좋아요 버튼</p>
              <span class="like-text">{{getLikeCount(comment.id)}}</span>
            </button>
          </h5>
          <p class="comment-box__desc">{{comment.content}}</p>
          <p class="comment-box__created-at">{{dateFormat(comment.createdDate)}}
            <span v-if="comment.loginid == loginid" class="del-seperator"> | </span>
            <span v-if="comment.loginid == loginid" class="del-comment" @click="delComment(comment.id)">댓글삭제</span>
          </p>
        </li>
      </ul>
    </div>
    </template>
  </div>
</template>
<script>
  import axios from 'axios';

  export default {
    name: 'post-comment',
    props: ['postId', 'isMemberPost', 'logined', 'photoUrl'],
    data() {
      return {
        comments: [],
        likes: [],
        me: [],
        content: '',
        progressing: false,
        loginid: null,
        mntoPrflList: [],
        postType: '',
      };
    },
    computed: {
      url() {
        return (this.isMemberPost) ? `/api/member-comments/${this.postId}` : `/api/comments/${this.postId}`;
      },
      commentLikeUrl() {
        return (this.isMemberPost) ? '/api/member-comments/like/' : '/api/comments/like/';
      },
      content_length() {
        if (this.content === null) {
          return 0;
        }
        return this.content.length;
      },
    },
    methods: {
      showMntPrfl(index) {
        $('.info-view-layer').css('display', 'none');
        $(`#info-view-layer-${index}`).css('display', 'block');
      },
      closeMntPrfl() {
        $('.info-view-layer').css('display', 'none');
      },
      getMntoName(id) {
        const result = this.mntoPrflList.find(item => item.postId === id);
        return (result) ? result.mntoName : '';
      },
      getMntoProfile(id) {
        let profile = [];
        const result = this.mntoPrflList.find(item => item.postId === id);
        if (result !== undefined && result.mntoProfile !== undefined) {
          profile = result.mntoProfile;
        }
        return profile;
      },
      dateFormat(date) {
        return `${date.slice(0, 4)}.${date.slice(5, 7)}.${date.slice(8)}`;
      },
      getCommentList() {
        axios.get(this.url).then((res) => {
          const result = res.data || [];
          this.comments = result.comments;
          this.likes = result.likes;
          this.me = result.me;
          this.loginid = result.loginid;
          if (this.isMemberPost) {
            this.postType = result.postType;
            if (this.postType === 'COUNSEL') {
              this.mntoPrflList = result.mntoPrflList;
            }
          }
        }).catch(e => console.log(e));
      },
      addComment() {
        if (this.progressing) return;
        if (!this.content) return;

        this.progressing = true;
        axios.post(this.url, { content: this.content }).then((res) => {
          const result = res.data || [];
          this.comments = result.comments;
          this.likes = result.likes;
          this.me = result.me;
          this.progressing = false;
          this.content = '';
        }).catch(() => alert('댓글을 달 수 없습니다.'));
      },
      delComment(id) {
        const delConfirm = window.confirm('정말 삭제하시겠습니까?');
        if (delConfirm) {
          axios.delete(`${this.url}/${id}`).then((res) => {
            const result = res.data || [];
            this.comments = result.comments;
            this.likes = result.likes;
            this.me = result.me;
            this.progressing = false;
            this.content = '';
          }).catch(() => alert('댓글을 삭제할 수 없습니다.'));
        }
      },
      getLikeCount(id) {
        const result = this.likes.find(item => item.id === id);
        return (result) ? result.count : 0;
      },
      isMyLike(id) {
        return this.me.includes(id);
      },
      getPhotoUrl(photoUrl) {
        return photoUrl || '/images/bg-my-default.png';
      },
      addLike(id) {
        if (this.me.includes(id)) return;
        if (this.progressing) return;

        this.progressing = true;
        axios.post(`${this.commentLikeUrl}${id}`).then((res) => {
          const index = this.likes.findIndex(item => item.id === id);
          if (index !== -1) this.likes.splice(index, 1);
          this.likes.push({
            id,
            count: res.data,
          });
          if (this.logined) this.me.push(id);
          this.progressing = false;
        }).catch(() => alert('좋아요를 할 수 없습니다.'));
      },
    },
    created() {
      this.getCommentList();
    },
  };
</script>
<style lang="scss" scoped>
  .del-seperator {
    margin: 0 10px;
  }
  .del-comment {
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// PostComment.vue?e786f012